import { ButtonV2, Preloader } from 'components';
import withContext, { ModalControllerStepsContext } from 'hocs/withContext';
import { applyFiltersStaff } from 'lib/utils';
import SelectPersonList from 'modals/common/SelectPersonList';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import FilterBar from './FilterBar';
import './style.scss';

const SelectAssociatedStaff = props => {
  const {
    data,
    defaultSelected = [],
    title = 'Select Staff',
    subtitle,
    label = 'Continue',
    loading = false,
    isContinueLoading = false,
    validations,
    disableInvalid,
    noResultText,
    selectType,
    isOptional,
    customCondition,
    renderPersonCard,
    onClose
  } = props;

  const staff = useMemo(() => data?.staff ?? [], [data?.staff]);

  const [filters, setFilters] = useState(() => {
    const base = { tagIds: [], search: '', roomId: '' };
    return customCondition ? { ...base, [customCondition.paramKey]: customCondition.paramValue } : base;
  });

  const [selectedStaff, setSelectedStaff] = useState(() => (data?.selected?.length ? data.selected : defaultSelected));

  useEffect(() => {
    if (Array.isArray(data?.selected)) setSelectedStaff(data.selected);
  }, [data?.selected]);

  const filteredStaff = useMemo(() => applyFiltersStaff(staff, filters, customCondition?.method), [
    staff,
    filters,
    customCondition
  ]);

  const updateFilters = useCallback(
    values => {
      setFilters(values);
      props.onFilter?.(values);
    },
    [props]
  );

  const save = useCallback(() => {
    data?.onSubmit?.(selectedStaff);
    onClose();
  }, [selectedStaff, data, props]);

  return (
    <div className="modal__wrapper select-kids">
      <div className="modal__header modal__header--bordered">
        <div className="modal__header-title">{title}</div>

        <div className="modal__filter-bar">
          <FilterBar onUpdate={updateFilters} />
        </div>

        {subtitle && <div className="modal__header-subtitle">{subtitle}</div>}
      </div>

      <div className="select-kids__container">
        {loading ? (
          <div className="select-kids__loading">
            <Preloader large />
          </div>
        ) : (
          <SelectPersonList
            persons={filteredStaff}
            allPersons={staff}
            selectedIds={selectedStaff}
            onSelect={setSelectedStaff}
            validations={validations}
            noResultText={noResultText}
            disableInvalid={disableInvalid}
            selectType={selectType}
            renderPersonCard={renderPersonCard}
            mapPersonIdToDisabledTooltip={data?.mapPersonIdToDisabledTooltip}
            type="teacher"
          />
        )}
      </div>

      <div className="modal__controls">
        <ButtonV2
          className="select-kids__submit"
          label={label}
          onClick={save}
          disabled={!isOptional && selectedStaff.length === 0}
          isLoading={isContinueLoading}
          data-cy="submit"
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  currentUser: state.currentUser.data
});

export default compose(withContext(ModalControllerStepsContext), connect(mapStateToProps))(SelectAssociatedStaff);
